 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1901BUDDHISMISNOTSCARY from '@/components/0_chapter1901buddhismisnotscary'
 import A_CHAPTER1902BUDDHANATIONS from '@/components/1_chapter1902buddhanations'
 import A_CHAPTER1903QUOTIENTCOUNTERMEASURE from '@/components/2_chapter1903quotientcountermeasure'
 import A_CHAPTER1904BOLDIDEAS from '@/components/3_chapter1904boldideas'
 import A_CHAPTER1905BUDDHISTSUTRA from '@/components/4_chapter1905buddhistsutra'
 import A_CHAPTER1906CARDIACBREAKTHROUGH from '@/components/5_chapter1906cardiacbreakthrough'
 import A_CHAPTER1907BUDDHISTBEINGS from '@/components/6_chapter1907buddhistbeings'
 import A_CHAPTER1908EVERYTHINGISANILLUSION from '@/components/7_chapter1908everythingisanillusion'
 import A_CHAPTER1909ITISNOTTRUETHATWHATYOUSEEWITHYOUREYESISNOTTRUE from '@/components/8_chapter1909itisnottruethatwhatyouseewithyoureyesisnottrue'
 import A_CHAPTER1910BUDDHISTOBJECTS from '@/components/9_chapter1910buddhistobjects'
 import A0_CHAPTER1911OCTAHEDRALBUDDHISTMIRROR from '@/components/10_chapter1911octahedralbuddhistmirror'
 import A1_CHAPTER1912CHULINGDUO from '@/components/11_chapter1912chulingduo'
 import A2_CHAPTER1913AGOODSENSEOFDOMINANCE from '@/components/12_chapter1913agoodsenseofdominance'
 import A3_CHAPTER1914BUDDHISTITEMSARENOTSOMETHINGYOUCANTRACEWITHYOURFINGER from '@/components/13_chapter1914buddhistitemsarenotsomethingyoucantracewithyourfinger'
 import A4_CHAPTER1915DHARMAAPPEARANCE from '@/components/14_chapter1915dharmaappearance'
 import A5_CHAPTER1916ALLOFYOUARENOTHINGMORETHANTHIS from '@/components/15_chapter1916allofyouarenothingmorethanthis'
 import A6_CHAPTER1917GOLDENFOG from '@/components/16_chapter1917goldenfog'
 import A7_CHAPTER1918SHATTEREDIMMORTALPALACE from '@/components/17_chapter1918shatteredimmortalpalace'
 import A8_CHAPTER1919LISHENG from '@/components/18_chapter1919lisheng'
 import A9_CHAPTER1920FLYINGKNIFEPATH from '@/components/19_chapter1920flyingknifepath'
 import A0_CHAPTER1921KNIFEQUESTION from '@/components/20_chapter1921knifequestion'
 import A1_CHAPTER1922ENTERTHEWORLDBYFEELING from '@/components/21_chapter1922entertheworldbyfeeling'
 import A2_CHAPTER1923THEDREAMOFTHEJIUZHOU from '@/components/22_chapter1923thedreamofthejiuzhou'
 import A3_CHAPTER1924HEAVENLYLAWPALACE from '@/components/23_chapter1924heavenlylawpalace'
 import A4_CHAPTER1925QINXIAOSHEART from '@/components/24_chapter1925qinxiaosheart'
 import A5_CHAPTER1926XINXINMORESECURE from '@/components/25_chapter1926xinxinmoresecure'
 import A6_CHAPTER1927KEYSANDLOCKS from '@/components/26_chapter1927keysandlocks'
 import A7_CHAPTER1928LOVEKNIFE from '@/components/27_chapter1928loveknife'
 import A8_CHAPTER1929BROKENKNIFEFORMATION from '@/components/28_chapter1929brokenknifeformation'
 import A9_CHAPTER1930TREASUREALLOCATION from '@/components/29_chapter1930treasureallocation'
 import A0_CHAPTER1931SABREKING from '@/components/30_chapter1931sabreking'
 import A1_CHAPTER1932COMPREHENSIONSOCIETY from '@/components/31_chapter1932comprehensionsociety'
 import A2_CHAPTER1933SNATCHTOKEN from '@/components/32_chapter1933snatchtoken'
 import A3_CHAPTER1934BROTHERLYAFFECTION from '@/components/33_chapter1934brotherlyaffection'
 import A4_CHAPTER1935GUESTATHOME from '@/components/34_chapter1935guestathome'
 import A5_CHAPTER1936HUAKUICOMPETITIONCONFERENCE from '@/components/35_chapter1936huakuicompetitionconference'
 import A6_CHAPTER1937THECOURTESANBELLEOFTHETHREESTEPASCENDANT from '@/components/36_chapter1937thecourtesanbelleofthethreestepascendant'
 import A7_CHAPTER1938NINETRIALS from '@/components/37_chapter1938ninetrials'
 import A8_CHAPTER1939YOUDARETOFIGHT from '@/components/38_chapter1939youdaretofight'
 import A9_CHAPTER1940THEFIASCOENDED from '@/components/39_chapter1940thefiascoended'
 import A0_CHAPTER1941XIRENLONGSCONDITION from '@/components/40_chapter1941xirenlongscondition'
 import A1_CHAPTER1942SECONDSTAGE from '@/components/41_chapter1942secondstage'
 import A2_CHAPTER1943HOWCOULDYOU from '@/components/42_chapter1943howcouldyou'
 import A3_CHAPTER1944NEWVICTORY from '@/components/43_chapter1944newvictory'
 import A4_CHAPTER1945WASHEEVENHUMAN from '@/components/44_chapter1945washeevenhuman'
 import A5_CHAPTER1946YUWENQIONG from '@/components/45_chapter1946yuwenqiong'
 import A6_CHAPTER1947XIRENLONGSOPPRESSION from '@/components/46_chapter1947xirenlongsoppression'
 import A7_CHAPTER1948YOUARECOURTINGDEATH from '@/components/47_chapter1948youarecourtingdeath'
 import A8_CHAPTER1949YUQINGAVENGEDHIMSELF from '@/components/48_chapter1949yuqingavengedhimself'
 import A9_CHAPTER1950QINXIAOSDETERMINATION from '@/components/49_chapter1950qinxiaosdetermination'
 import A0_CHAPTER1951ZYGOCENTRIC from '@/components/50_chapter1951zygocentric'
 import A1_CHAPTER1952TORESPECTTHEHEARTANDACTASONESOWNMIND from '@/components/51_chapter1952torespecttheheartandactasonesownmind'
 import A2_CHAPTER1953MEDALLION from '@/components/52_chapter1953medallion'
 import A3_CHAPTER1954VERBATIM from '@/components/53_chapter1954verbatim'
 import A4_CHAPTER1955INNOCENT from '@/components/54_chapter1955innocent'
 import A5_CHAPTER1956FIGHTQIUWU from '@/components/55_chapter1956fightqiuwu'
 import A6_CHAPTER1957BEGFORMERCY from '@/components/56_chapter1957begformercy'
 import A7_CHAPTER1958DOWNTHESTEPS from '@/components/57_chapter1958downthesteps'
 import A8_CHAPTER1959AHINTOFPROFOUNDMEANING from '@/components/58_chapter1959ahintofprofoundmeaning'
 import A9_CHAPTER1960DESCENTOFTHETINIMMORTALS from '@/components/59_chapter1960descentofthetinimmortals'
 import A0_CHAPTER1961BEYOUNGANDSHOULDBEFRIVOLOUS from '@/components/60_chapter1961beyoungandshouldbefrivolous'
 import A1_CHAPTER1962ACTIVATEDHONGMING from '@/components/61_chapter1962activatedhongming'
 import A2_CHAPTER1963THEHEAVENLYMOUNTAINCITYLORDDESCENDED from '@/components/62_chapter1963theheavenlymountaincitylorddescended'
 import A3_CHAPTER1964COMPREHENSIONHASAMANTRA from '@/components/63_chapter1964comprehensionhasamantra'
 import A4_CHAPTER1965SEEHEAVENLYMOUNTAINCITYLORD from '@/components/64_chapter1965seeheavenlymountaincitylord'
 import A5_CHAPTER1966LOOKATYOURGOODFORTUNE from '@/components/65_chapter1966lookatyourgoodfortune'
 import A6_CHAPTER1967TWOSTEPSTOHEAVENQINXIAO from '@/components/66_chapter1967twostepstoheavenqinxiao'
 import A7_CHAPTER1968WALKYOURWAY from '@/components/67_chapter1968walkyourway'
 import A8_CHAPTER1969ROBBERY from '@/components/68_chapter1969robbery'
 import A9_CHAPTER1970ILLJUSTGIVEITTOYOUGUYS from '@/components/69_chapter1970illjustgiveittoyouguys'
 import A0_CHAPTER1971THEDARKISHQINXIAO from '@/components/70_chapter1971thedarkishqinxiao'
 import A1_CHAPTER1972BEGFORMERCY from '@/components/71_chapter1972begformercy'
 import A2_CHAPTER1973SHOWOFGOODFAITH from '@/components/72_chapter1973showofgoodfaith'
 import A3_CHAPTER1974EXCHANGESECRETTECHNIQUES from '@/components/73_chapter1974exchangesecrettechniques'
 import A4_CHAPTER1975QINXIAOSCONSIDERATION from '@/components/74_chapter1975qinxiaosconsideration'
 import A5_CHAPTER1976THEENERGYOFTHEIMMORTALUNIONCHAMBEROFCOMMERCE from '@/components/75_chapter1976theenergyoftheimmortalunionchamberofcommerce'
 import A6_CHAPTER1977DISCIPLELARGECOMPETITION from '@/components/76_chapter1977disciplelargecompetition'
 import A7_CHAPTER1978RIGHTEOUSINDIGNATION from '@/components/77_chapter1978righteousindignation'
 import A8_CHAPTER1979THERESHOULDBERIGHTEOUSNESSINHISHEART from '@/components/78_chapter1979thereshouldberighteousnessinhisheart'
 import A9_CHAPTER1980KNIFEDECISION from '@/components/79_chapter1980knifedecision'
 import A0_CHAPTER1981THELORDOFFUYANIMMORTALPALACEDESCENDED from '@/components/80_chapter1981thelordoffuyanimmortalpalacedescended'
 import A1_CHAPTER1982HEAVENSPRIDE from '@/components/81_chapter1982heavenspride'
 import A2_CHAPTER1983PROMOTETHESONOFPRIDE from '@/components/82_chapter1983promotethesonofpride'
 import A3_CHAPTER1984THEBENEFITSOFPROUDCHILDREN from '@/components/83_chapter1984thebenefitsofproudchildren'
 import A4_CHAPTER1985BROKENSWORD from '@/components/84_chapter1985brokensword'
 import A5_CHAPTER1986ASLIVEROFHOLYPOWER from '@/components/85_chapter1986asliverofholypower'
 import A6_CHAPTER1987INVIOLABLEWILL from '@/components/86_chapter1987inviolablewill'
 import A7_CHAPTER1988YOUDONTNEEDAREASONTOHATESOMEONE from '@/components/87_chapter1988youdontneedareasontohatesomeone'
 import A8_CHAPTER1989ZIZYPHUSHIRSUTUM from '@/components/88_chapter1989zizyphushirsutum'
 import A9_CHAPTER1990HEHADTOAGREEEVENIFHEDIDNTWANTTO from '@/components/89_chapter1990hehadtoagreeevenifhedidntwantto'
 import A0_CHAPTER1991COMPROMISE from '@/components/90_chapter1991compromise'
 import A1_CHAPTER1992IMMORTALWITHEREDCLOUDSDEDUCTION from '@/components/91_chapter1992immortalwitheredcloudsdeduction'
 import A2_CHAPTER1993UNBELIEVABLE from '@/components/92_chapter1993unbelievable'
 import A3_CHAPTER1994DRAGONSLAYINGSWORD from '@/components/93_chapter1994dragonslayingsword'
 import A4_CHAPTER1995ALLTHETIMEWAITINGFORYOU from '@/components/94_chapter1995allthetimewaitingforyou'
 import A5_CHAPTER1996LIMITLESSDEPARTUREFIELD from '@/components/95_chapter1996limitlessdeparturefield'
 import A6_CHAPTER1997SELECTIONOFTHEHOLYCONSORT from '@/components/96_chapter1997selectionoftheholyconsort'
 import A7_CHAPTER1998ATRANSACTION from '@/components/97_chapter1998atransaction'
 import A8_CHAPTER1999ENEMIESHAVEANARROWROAD from '@/components/98_chapter1999enemieshaveanarrowroad'
 import A9_CHAPTER2000BARBARIANLIFE from '@/components/99_chapter2000barbarianlife'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1901buddhismisnotscary",
 			"name" : "0_chapter1901buddhismisnotscary",
 			"component" : A_CHAPTER1901BUDDHISMISNOTSCARY
 		},
 		{
 			"path" : "/1_chapter1902buddhanations",
 			"name" : "1_chapter1902buddhanations",
 			"component" : A_CHAPTER1902BUDDHANATIONS
 		},
 		{
 			"path" : "/2_chapter1903quotientcountermeasure",
 			"name" : "2_chapter1903quotientcountermeasure",
 			"component" : A_CHAPTER1903QUOTIENTCOUNTERMEASURE
 		},
 		{
 			"path" : "/3_chapter1904boldideas",
 			"name" : "3_chapter1904boldideas",
 			"component" : A_CHAPTER1904BOLDIDEAS
 		},
 		{
 			"path" : "/4_chapter1905buddhistsutra",
 			"name" : "4_chapter1905buddhistsutra",
 			"component" : A_CHAPTER1905BUDDHISTSUTRA
 		},
 		{
 			"path" : "/5_chapter1906cardiacbreakthrough",
 			"name" : "5_chapter1906cardiacbreakthrough",
 			"component" : A_CHAPTER1906CARDIACBREAKTHROUGH
 		},
 		{
 			"path" : "/6_chapter1907buddhistbeings",
 			"name" : "6_chapter1907buddhistbeings",
 			"component" : A_CHAPTER1907BUDDHISTBEINGS
 		},
 		{
 			"path" : "/7_chapter1908everythingisanillusion",
 			"name" : "7_chapter1908everythingisanillusion",
 			"component" : A_CHAPTER1908EVERYTHINGISANILLUSION
 		},
 		{
 			"path" : "/8_chapter1909itisnottruethatwhatyouseewithyoureyesisnottrue",
 			"name" : "8_chapter1909itisnottruethatwhatyouseewithyoureyesisnottrue",
 			"component" : A_CHAPTER1909ITISNOTTRUETHATWHATYOUSEEWITHYOUREYESISNOTTRUE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js